import { Component, OnInit, Inject     } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogsReturnCode             } from 'src/app/enums/dialogs/returnCode.enum';
import { HandlerManager                } from 'src/app/managers/handler/handler.manager';
import { LoadingManager                } from 'src/app/managers/loading/loading.manager';
import { SessionManager                } from 'src/app/managers/session/session.manager';
import { User                          } from 'src/app/beans/login/user/user.bean';
import { Result } from 'src/app/beans/result/result.bean';
import { SlotModelAuto } from 'src/app/beans/slot-model/slot-model.auto.bean';
import { SlotModel } from 'src/app/beans/slot-model/slot-model.bean';
import { Organization } from 'src/app/beans/organization/organization.bean';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';

@Component
({
  selector: 'slot.model.copy.dialog',
  templateUrl: './slot.model.copy.dialog.html',
  styleUrls: ['./slot.model.copy.dialog.scss'],
})

export class ModelCopyDialog implements OnInit 
{

    dayList: any[] =
    [
        {
        day   : "day.monday",
        active: true,
        base : false
        },
        {
        day   : "day.tuesday",
        active: true,
        base : false
        },
        {
        day   : "day.wednesday",
        active: true,
        base : false
        },
        {
        day   : "day.thursday",
        active: true,
        base : false
        },
        {
        day   : "day.friday",
        active: true,
        base : false
        },
        {
        day   : "day.saturday",
        active: false,
        base : false
        },
        {
        day   : "day.sunday",
        active: false,
        base : false
        },
    ]

  constructor
  (
    private dialogRef : MatDialogRef<ModelCopyDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    
    private _handler : HandlerManager,
    private _loader  : LoadingManager,
    private _session : SessionManager,
    private _utils   : UtilsManager
  ) {}

  ngOnInit(): void
  {
    this.init()
  }

  async init()
  {
    this.dayList[this.data.curDay].base = true
    this.dayList[this.data.curDay].active = false
  }


  cancel()
  {    
    this.dialogRef.close
    ( 
      {
        code: DialogsReturnCode.OPERATION_DECLINED
      }
    )
  }

  apply()
  {
      let days = []
      for (let index = 0; index < this.dayList.length; index++) {
          if (this.dayList[index].active && !this.dayList[index].base) days.push (index + 1);         
      }

    this.dialogRef.close
    ( 
      {
        code: DialogsReturnCode.SLOTMODEL_SLOT,
        days
      }
    )
  }

}